import * as _ from "lodash";
import { MeterReadingContractDetailMeterPlans } from "./MeterReadingContractDetailMeterPlans";
import { MeterReadingContractDetailProducts } from "./meterReadingContractDetailProducts";
import entityBase from "entityBase";

export class MeterReadingContractDetail extends entityBase {
  contract_id: string;
  contract_name: string;
  name1: string;
  name2: string;
  start_dt: Date;
  start_dttm: string;
  end_dt: Date;
  end_dttm: string;
  user_def20: string;
  contr_inv_rule: string;
  meter_inv_rule: string;
  ext_invoice_attachm_mail_addr: string;
  contr_meter_plan: MeterReadingContractDetailMeterPlans[];
  contr_product: MeterReadingContractDetailProducts[];

  constructor(item) {
    super();
    this.contract_id = item.contract.contract_id;
    this.contract_name = item.contract.contract_name;
    if (item.contract.c_contract_places_view) {
      this.name1 = item.contract.c_contract_places_view.name1;
      this.name2 = item.contract.c_contract_places_view.name2;
    }
    this.start_dt = this.formatJSONDate(item?.contract?.start_dt);
    this.start_dttm = this.toDefaultDateString(this.start_dt);
    this.end_dt = this.formatJSONDate(item?.contract?.end_dt);
    this.end_dttm = this.toDefaultDateString(this.end_dt);
    this.user_def20 = item.contract.user_def20;
    this.contr_inv_rule = item.contract.contr_inv_rule;
    this.meter_inv_rule = item.contract.meter_inv_rule;
    this.ext_invoice_attachm_mail_addr = item.contract.ext_invoice_attachm_mail_addr;

    if (Array.isArray(item.meter_plans)) {
      this.contr_meter_plan = _.map(item.meter_plans, (o) => {
        return new MeterReadingContractDetailMeterPlans(o, item.products, item.bill_period, item.contract);
      });
    } else if (item.meter_plans) {
      this.contr_meter_plan = [
        new MeterReadingContractDetailMeterPlans(item.meter_plans, item.products, item.bill_period, item.contract),
      ];
    }

    if (Array.isArray(item.products)) {
      this.contr_product = _.map(item.products, (o) => {
        return new MeterReadingContractDetailProducts(o, item.meter_plans);
      });
    } else if (item.products) {
      this.contr_product = [new MeterReadingContractDetailProducts(item.products, item.meter_plans)];
    }
  }
}
